import "./QuestionCheckbox.scss";
import cn from "classnames";

const CheckboxOption = ({ label, value, selected, onSelect, disabled }) =>  {
  const isChecked = Array.isArray(selected)
    ? selected.includes(value)
    : Boolean(selected);

  return (
    <li
      className={cn("checkbox__item", { "checkbox__item--disabled": disabled })}
    >
      <label className="checkbox__label">
        <input
          type="checkbox"
          className="checkBox"
          value={value}
          checked={isChecked}
          disabled={disabled}
          onChange={() => onSelect(value)}
        />
        <span className="checkbox__text">{label ?? value}</span>
      </label>
    </li>
  );
}

export default CheckboxOption;
